var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back_button"},[_c('router-link',{staticClass:"back_button__a",attrs:{"to":_vm.route}},[_c('i',{staticClass:"fa fa-arrow-left"}),_c('span',[_vm._v(" "+_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }